import React from 'react'
import { Field } from 'redux-form'
import { useSelector } from 'react-redux'

import {
  Input,
  Select,
  RadioGroup,
  Checkbox,
  DatePicker,
  Textarea,
} from '../../../../../../../../../itrust_common/components/form'
import { humanize } from '../../../../../../../../../itrust_common/components/HelperFunctions'
import { CountriesStates } from '../../../../../../../../../itrust_common/components/CountriesStates'
import { getEyefinityProviderOptions } from './getEyefinityProviderOptions'

export default function EyefinityFields({ field, disabled = false, showRequiredMark = false }) {
  const {
    type,
    label,
    data_source,
    name,
    options = [],
    required,
  } = field

  const isRequiredMark = showRequiredMark && type !== 'checkbox'
  const fieldLabel = isRequiredMark ? (
    <>
      {humanize(label)} <span className="text-danger">*</span>
    </>
  ) : humanize(label)

  const services = useSelector(state => state.visionInsurance?.services || [])
  const eyefinityProviderOptions = getEyefinityProviderOptions(services)

  const formattedOptions = options.map(option => ({
    ...option,
    value: option.value ?? '',
  }))

  const excludedStates = ['AS', 'FM', 'MH', 'MP', 'PW']

  const usStates =
    (CountriesStates.find(
      item => item.countryName === 'United States'
    )?.regions || []).filter(
      state => !excludedStates.includes(state.shortCode)
    )
  const commonProps = {
    name: label,
    label: fieldLabel,
    required: isRequiredMark || required,
    format: (value) => (typeof value === 'object' && value !== null && !(value instanceof Date) ? '' : value),
  }


  switch (type) {
    case 'text':
      return (
        <Field
          className="form-control"
          wrapperClassName="form-group"
          {...commonProps}
          disabled={disabled}
          component={Input}
        />
      )

    case 'dropdown':
      if (data_source === 'United States') {
        return (
          <Field
            {...commonProps}
            isOpen={true}
            component={Select}
            data={usStates}
            textField="name"
            valueField="shortCode"
            className="form-control"
            wrapperClassName="form-group"
          />
        )
      }

      if (data_source === 'eyefinity_providers') {
        return (
          <Field
            {...commonProps}
            disabled={disabled}
            component={Select}
            data={eyefinityProviderOptions}
            textField="label"
            valueField="value"
            placeholder="--Please select a provider--"
            className='form-control'
            wrapperClassName="form-group"
          />
        )
      }

      return (
        <Field
          {...commonProps}
          textField="label"
          valueField="value"
          component={Select}
          disabled={disabled}
          data={formattedOptions}
          className='form-control'
          wrapperClassName="form-group"
        />
      )


    case 'radio':
      return (
        <RadioGroup
          name={commonProps.name}
          options={formattedOptions}
          wrapperClasses="form-group"
          className="form-control"
          label={commonProps.label}
        />
      )

    case 'checkbox':
      return (
        <Field
          {...commonProps}
          disabled={disabled}
          component={Checkbox}
          className="form-control"
          wrapperClassName="form-group"
        />
      )

    case 'text_area':
      return (
        <Field
          className='form-control'
          wrapperClassName='form-group'
          rows={3}
          {...commonProps}
          disabled={disabled}
          component={Textarea}
        />
      )

    case 'date':
      return (
        <Field
          {...commonProps}
          disabled={disabled}
          component={DatePicker}
          className="form-control"
          wrapperClassName="form-group"
          max={new Date()}
        />
      )

    default:
      return null
  }
}
